import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { MouseEvent, ReactNode, useState } from 'react';

interface DataTableCellContentProps {
  children: ReactNode;
  // Plain-text cells pass their value; custom cells own their own hover behavior.
  fullText?: string;
  sx: SxProps<Theme>;
}

export default function DataTableCellContent({
  children,
  fullText,
  sx,
}: DataTableCellContentProps) {
  const [isOpen, setIsOpen] = useState(false);

  // Relies on the cell content clipping its overflow horizontally (see `contentSx` in getColumnSlots).
  const handleMouseEnter = (event: MouseEvent<HTMLElement>) => {
    setIsOpen(event.currentTarget.scrollWidth > event.currentTarget.clientWidth);
  };

  const handleMouseLeave = () => setIsOpen(false);

  if (!fullText) {
    return <Box sx={sx}>{children}</Box>;
  }

  return (
    <Tooltip
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={isOpen}
      // Keeps line breaks in multi-line cell text such as order notes.
      slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}
      title={fullText}
    >
      <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} sx={sx}>
        {children}
      </Box>
    </Tooltip>
  );
}
